/*
 * @Author: Niklaus
 * @Date: 2024-04-23 10:04:57
 * @LastEditTime: 2026-06-06 17:34:33
 * @LastEditors: Niklaus
 * @Description:
 */
import Vue from "vue";

import App from "./App";

import mainConfig from "./main/index";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";

Vue.prototype.$FileSaver = FileSaver; //设置全局
Vue.prototype.$XLSX = XLSX; //设置全局
Vue.config.productionTip = false;
Vue.config.devtools = true;
import fullscreen from "vue-fullscreen";

Vue.use(fullscreen);

let app = new Vue({
  ...mainConfig,
  render: (h) => h(App),
});

Vue.config.devtools = process.env.NODE_ENV === "development";

app.$mount("#app");
